module.exports = __webpack_public_path__ + "img/slider_click-scroll.c69e95a7.png";